import React from 'react';
import { BreadcrumbItem, SingleBreadcrumbItem } from 'framework/ui/BreadCrumbs';
import { useParams, useNavigate } from 'react-router-dom';
import { useFormContext } from 'framework/form';
import { useShowContext } from 'framework/show';
import { useVacancyGroupId, useVacancyGroupUrl } from 'domain/recruiting/newVacancy/routing';
import useVacancyGroupBreadcrumbsMenu from 'domain/recruiting/newVacancy/show/vacancyGroup/shared/useVacancyGroupBreadcrumbsMenu';
import SingleVacancyBreadcrumbs from 'domain/recruiting/newVacancy/shared/SingleVacancyBreadcrumbs';

const VISIBLE_VACANCY_GROUP_TABS = ['Information', 'Publications', 'Sourcing', 'History'];

interface SingleVacancyGroupPublicationBreadcrumbsProps {
  children?: React.ReactNode;
}

const SingleVacancyGroupPublicationBreadcrumbs = ({ children }: SingleVacancyGroupPublicationBreadcrumbsProps) => {
  const { data } = useShowContext();
  const { data: formData } = useFormContext();
  const { publicationId } = useParams<Dictionary<string>>();
  const vacancyGroupId = useVacancyGroupId();
  const { getPublicationUrl, getPublicationsUrl, getSingleEntityUrl } = useVacancyGroupUrl();
  const navigate = useNavigate();

  const vacancyGroupTabs = useVacancyGroupBreadcrumbsMenu().filter(({ label }) =>
    VISIBLE_VACANCY_GROUP_TABS.includes(label),
  );

  const entity = formData?.name || data.getValueBySource('name');
  const vacancyGroupEntity = formData?.vacancyGroupName || data.getValueBySource('vacancyGroupName');

  return (
    <SingleVacancyBreadcrumbs
      entity={vacancyGroupEntity}
      onClickCallback={() => navigate(getSingleEntityUrl(vacancyGroupId))}
    >
      <BreadcrumbItem options={vacancyGroupTabs} link={getPublicationsUrl(vacancyGroupId)} showOptionsWhenInactive>
        <span>Publications</span>
      </BreadcrumbItem>

      <SingleBreadcrumbItem entity={entity} link={getPublicationUrl(vacancyGroupId, publicationId!)} />

      {children}
    </SingleVacancyBreadcrumbs>
  );
};

export default SingleVacancyGroupPublicationBreadcrumbs;
